import { Component, Inject, OnInit } from '@angular/core';
//import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DetachNodeAction, MultiNodeActionDTO } from '../../../../core/models/node';
import { NodeService } from '../../../../core/services/node.service';

@Component({
  selector: 'app-detach-nodes',
  templateUrl: './detach-nodes.component.html',
  styleUrls: ['./detach-nodes.component.scss']
})
export class DetachNodesComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<DetachNodesComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
        vmInfoes: DetachNodeAction[];
        workStationNames: string[];
    },
    private nodeService: NodeService
  ) { }

  dataTosend: MultiNodeActionDTO = {
    attachObj: null,
    detachObj: []
  }
;
  workStationsAll: DetachNodeAction[] = this.data.vmInfoes;
  sel: string[] = this.data.workStationNames;
  selectedVMs = [];

  ngOnInit(): void {
    this.selectedVMs = this.workStationsAll.filter(el => this.sel.includes(el.wsName));
    if (this.selectedVMs?.length == 1 && !this.selectedVMs![0].deploymentName) {
      this.dialog.close({ status: false, data: "Node(s) is already unassigned." })
    }
    else {
      let allUnassigned = this.selectedVMs?.every(vm => !vm?.deploymentName)
      if (allUnassigned) {
        this.dialog.close({ status: false, data: "Node(s) is already unassigned." })
      }
    }
  }

  addWorkStationObject($event, vmName) {
    if (this.dataTosend.detachObj.length > 0) {
      if (this.dataTosend.detachObj.find(el => el.wsName === vmName)) {
        this.dataTosend.detachObj.find(el => el.wsName === vmName).deploymentName = $event.value.join(",")
      } else {
        this.dataTosend.detachObj.push(
          {
            wsName: vmName, deploymentName: $event.value.join(",")
          }
        )
      }
    } else {
      this.dataTosend.detachObj.push(
        {
          wsName: vmName, deploymentName: $event.value.join(",")
        }
      ) }
  }

  onClose() {
    this.dialog.close({ status: false, data: "No Deployments selected." })
  }

  onSubmit() {
    this.dataTosend.detachObj = this.dataTosend.detachObj.filter(el => el.deploymentName != "")
    if (this.dataTosend?.detachObj?.length < 1) {
      this.dialog.close({ status: false, data: this.dataTosend })
      return;
    }
    this.dialog.close({ status: true, data: this.dataTosend })
  }
}
